import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from '@mui/material/styles';
import FormFillPage from "./FormFillPage";
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import theme from '../../assets/theme';
import '../../assets/base.css';


createRoot(document.getElementById("avocado-form-fill-root")).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* CssBaseline paints body with theme.palette.background.default
                (#FAFAFA, not white) — this page is meant to be embeddable and
                blend into whatever page it's embedded in, so that opaque fill
                has to go for the "Page Background Color"/transparent-card
                options to actually show anything behind the form. */}
            <GlobalStyles styles={{ body: { backgroundColor: 'transparent' } }} />
            <FormFillPage />
        </ThemeProvider>
    </StrictMode >,
);
